import React from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import htmlicon from "../../../assets/images/skill-icon/html.png";
import cssicon from "../../../assets/images/skill-icon/css.png";
import bootstrapicon from "../../../assets/images/skill-icon/bootstrap.png";
import jsicon from "../../../assets/images/skill-icon/javascript.png";
import reacticon from "../../../assets/images/skill-icon/react.png";
import sassicon from "../../../assets/images/skill-icon/sass.png";
import nodeicon from "../../../assets/images/skill-icon/node.png";
import mongodbicon from "../../../assets/images/skill-icon/mongodb.png";
import expressicon from "../../../assets/images/skill-icon/expressjs.png";
import giticon from "../../../assets/images/skill-icon/git.png";
import firebaseicon from "../../../assets/images/skill-icon/firebase.png";
import herokuicon from "../../../assets/images/skill-icon/heroku.png";
import netlifyicon from "../../../assets/images/skill-icon/netlify.png";
import figmaicon from "../../../assets/images/skill-icon/figma.png";
import materialicon from "../../../assets/images/skill-icon/mui.png";
import tailwindicon from "../../../assets/images/skill-icon/tailwind.png";
import Aos from "aos";

const SkillSection = () => {
  React.useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);
  return (
    <div id="skills" className="skill-section">
      <div className="skill-dot">
        <h2 className="text-center">Skills</h2>
        <p className="text-center">What I'll do for you</p>
      </div>
      <Container className="skills">
        <Row xs={1} md={2} className="g-4">
          <Col data-aos="fade-up">
            <Card className="service-card service-1">
              <h3 className="text-center mb-3">Frontend skills</h3>
              <Row md={6}>
                <Col>
                  <img className="img-fluid" src={htmlicon} alt="" />
                  <p className="text-center">HTML</p>
                </Col>
                <Col>
                  <img className="img-fluid" src={cssicon} alt="" />
                  <p className="text-center">CSS</p>
                </Col>
                <Col>
                  <img className="img-fluid" src={bootstrapicon} alt="" />
                  <p className="text-center">Bootstrap</p>
                </Col>
                <Col>
                  <img className="img-fluid" src={jsicon} alt="" />
                  <p className="text-center">Javascript</p>
                </Col>
                <Col>
                  <img className="img-fluid" src={reacticon} alt="" />
                  <p className="text-center">React</p>
                </Col>
                <Col>
                  <img className="img-fluid" src={sassicon} alt="" />
                  <p className="text-center">SASS</p>
                </Col>
              </Row>
            </Card>
          </Col>
          <Col data-aos="fade-up">
            <Card className="service-card service-2">
              <h3 className="text-center mb-3">Backend skills</h3>
              <Row md={6}>
                <Col>
                  <img className="img-fluid" src={nodeicon} alt="" />
                  <p className="text-center">Node Js</p>
                </Col>
                <Col>
                  <img className="img-fluid" src={mongodbicon} alt="" />
                  <p className="text-center">MongoDB</p>
                </Col>
                <Col>
                  <img className="img-fluid" src={expressicon} alt="" />
                  <p className="text-center">Express Js</p>
                </Col>
              </Row>
            </Card>
          </Col>
          <Col data-aos="fade-up">
            <Card className="service-card service-3">
              <h3 className="text-center mb-3">Tools</h3>
              <Row md={6}>
                <Col>
                  <img className="img-fluid" src={giticon} alt="" />
                  <p className="text-center">Git</p>
                </Col>
                <Col>
                  <img className="img-fluid" src={firebaseicon} alt="" />
                  <p className="text-center">Firebase</p>
                </Col>
                <Col>
                  <img className="img-fluid" src={herokuicon} alt="" />
                  <p className="text-center">Heroku</p>
                </Col>
                <Col>
                  <img className="img-fluid" src={netlifyicon} alt="" />
                  <p className="text-center">Netlify</p>
                </Col>
              </Row>
            </Card>
          </Col>
          <Col data-aos="fade-up">
            <Card className="service-card service-4">
              <h3 className="text-center mb-3">Familiar With</h3>
              <Row md={6}>
                <Col>
                  <img className="img-fluid" src={figmaicon} alt="" />
                  <p className="text-center">Figma</p>
                </Col>
                <Col>
                  <img className="img-fluid" src={materialicon} alt="" />
                  <p className="text-center">Material</p>
                </Col>
                <Col>
                  <img className="img-fluid" src={tailwindicon} alt="" />
                  <p className="text-center">Tailwind</p>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default SkillSection;
